import { ConfigRequestTarget, SearchDistributionMode } from '@/types'

// App Configuration
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Uyari Admin'
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0'
export const API_URL = import.meta.env.VITE_API_URL || ''

// Pagination
export const DEFAULT_PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

// Roles
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  FINANCE: 'finance',
  SUPPORT: 'support',
  USER: 'user',
} as const

export type Role = (typeof ROLES)[keyof typeof ROLES]

// Role Labels
export const ROLE_LABELS: Record<Role, string> = {
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.ADMIN]: 'Administrador',
  [ROLES.FINANCE]: 'Finanzas',
  [ROLES.SUPPORT]: 'Soporte',
  [ROLES.USER]: 'Usuario',
}

// Status
export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
  PENDING: 'pending',
} as const

// Coupon Types
export const COUPON_TYPES = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed',
} as const

export type CouponType = (typeof COUPON_TYPES)[keyof typeof COUPON_TYPES]

export const COUPON_TYPE_LABELS: Record<CouponType, string> = {
  [COUPON_TYPES.PERCENTAGE]: 'Porcentaje',
  [COUPON_TYPES.FIXED]: 'Monto Fijo',
}

// Coupon Applies To
export const COUPON_APPLIES_TO = {
  SUBSCRIPTION: 'subscription',
  DOCUMENTS: 'documents',
  BOTH: 'both',
} as const

export type CouponAppliesTo = (typeof COUPON_APPLIES_TO)[keyof typeof COUPON_APPLIES_TO]

export const COUPON_APPLIES_TO_LABELS: Record<CouponAppliesTo, string> = {
  [COUPON_APPLIES_TO.SUBSCRIPTION]: 'Suscripción',
  [COUPON_APPLIES_TO.DOCUMENTS]: 'Documentos',
  [COUPON_APPLIES_TO.BOTH]: 'Ambos',
}

// Chart Colors
export const CHART_COLORS = {
  primary: 'rgb(var(--primary))',
  secondary: 'rgb(var(--secondary))',
  muted: 'rgb(var(--muted))',
  accent: 'rgb(var(--accent))',
  destructive: 'rgb(var(--destructive))',
  success: '#22C55E',
  warning: '#E5A825',
  info: '#4A7C9B',
}

// Date Formats
export const DATE_FORMATS = {
  display: 'dd MMM yyyy',
  input: 'yyyy-MM-dd',
  api: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
} as const

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'admin-auth-token',
  THEME: 'admin-theme',
  SIDEBAR_COLLAPSED: 'admin-sidebar-collapsed',
} as const

// Config Requests inbox — target labels (card 93/111). Shared by RequestInboxPage
// and UserConfigPage's "Solicitudes" tab.
export const CONFIG_REQUEST_TARGET_LABELS: Record<ConfigRequestTarget, string> = {
  alerts: 'Alertas',
  scheduled_reports: 'Reportes programados',
  search_settings: 'Configuración de búsqueda',
}

// Search distribution mode labels — mirrors sl-react-core's canonical map
// (modules/requests/types/configRequest.types.ts / DistributionModeSelector.tsx).
export const DISTRIBUTION_MODE_LABELS: Record<SearchDistributionMode, string> = {
  balanced: 'Equilibrado',
  custom: 'Personalizado',
  single_platform: 'Plataforma única',
  news_priority: 'Prioridad noticias',
}
